export enum LoginSource {
  LOGIN,
  INDICATION,
  QUOTE_SETUP_PRESET,
}

export enum LoginView {
  LOGIN,
  SIGNUP,
}

export enum RegistrationRole {
  POLICYHOLDER = 'POLICYHOLDER',
  BILLING_CONTACT = 'BILLING_CONTACT',
  BROKER_PRODUCER = 'BROKER_PRODUCER',
}
